// extracted by mini-css-extract-plugin
export default {"container":"HeizungsCheck-module__container-co4R0t"};